<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="headline">
        {{ $t('clone_colors') }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            append-icon="fa-search"
            outlined
            dense
          ></v-text-field>

          <v-data-table
            :headers="headers"
            :items="colors"
            :search="search"
            :loading="loading"
            v-model="selected"
            show-select
            item-key="id"
            class="elevation-1"
            :items-per-page="10"
          >
            <template v-slot:item.name="{ item }">
              {{
                $te(item.name.toLowerCase().replace(/\s+/g, '_'))
                  ? $t(item.name.toLowerCase().replace(/\s+/g, '_'))
                  : item.name
              }}
            </template>
            <template v-slot:item.image_path="{ item }">
              <div class="d-flex align-center">
                <v-img
                  v-if="item.image_path"
                  :src="item.image_path"
                  max-width="30"
                  max-height="30"
                  class="rounded mr-2"
                ></v-img>
              </div>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="blue darken-1" text @click="save" :loading="loading">{{
          $tc('save', 1)
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: '',
      loading: false,
      colors: [],
      selected: []
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    }),
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    companyPk() {
      return this.company ? this.company.pk || this.company.id : null
    },
    headers() {
      return [
        { text: this.$t('name'), value: 'name' },
        { text: this.$t('image'), value: 'image_path' }
      ]
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.selected = []
        this.fetchGlobalColors()
      }
    }
  },
  methods: {
    async fetchGlobalColors() {
      this.loading = true
      try {
        const response = await this.$api.product.apparelcolor.list({
          opt: {
            params: { global: true, no_page: true }
          }
        })
        this.colors = response.data.results || response.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (this.selected.length === 0) {
        this.$toast.warning(this.$t('select_at_least_one_color'))
        return
      }
      try {
        const colorIds = this.selected.map((c) => c.id)
        await this.$api.product.apparelcolor.clone({
          form: {
            color_ids: colorIds,
            company_id: this.companyPk
          },
          opt: { skipErrorToast: true }
        })
        this.$toast.success(this.$t('saved'))
        this.$emit('done')
        this.dialog = false
      } catch (error) {
        console.error(error)
        if (error.response && error.response.data) {
          const data = error.response.data
          if (data.detail) {
            this.$toast.error(
              this.$t(data.detail, { name: data.name || '' }) || data.detail
            )
          } else if (typeof data === 'object') {
            const firstKey = Object.keys(data)[0]
            const msg = Array.isArray(data[firstKey])
              ? data[firstKey][0]
              : data[firstKey]
            this.$toast.error(this.$t(msg) || msg)
          } else {
            this.$toast.error(this.$t('image_error_message'))
          }
        } else {
          this.$toast.error(this.$t('image_error_message'))
        }
      }
    },
    getPreviewStyle(colors) {
      if (!colors || colors.length === 0)
        return { backgroundColor: 'transparent' }
      const baseStyle = {
        width: '20px',
        height: '20px',
        borderRadius: '4px',
        marginRight: '8px',
        border: '1px solid #ccc'
      }

      if (colors.length === 1) {
        return { ...baseStyle, backgroundColor: colors[0] }
      }

      const step = 100 / colors.length
      let gradientParts = []
      for (let i = 0; i < colors.length; i++) {
        gradientParts.push(`${colors[i]} ${i * step}% ${(i + 1) * step}%`)
      }
      return {
        ...baseStyle,
        background: `conic-gradient(from 180deg, ${gradientParts.join(', ')})`
      }
    }
  }
}
</script>
